export class ChatService {
  constructor($http) {
    this.http = $http;
  }

  getChatList(page, limit){
    return this.http.get(`/api/chat/list/${page}/${limit}`);
  }

  getChat(chat_room){
    return this.http.get(`/api/chat/id/${chat_room}`);
  }

  removeChatList(chatList) {
    return this.http.post(`/api/chat/delete`, chatList)
  }

  getMessages(chat_room, page, limit){
    return this.http.get(`/api/message/list/${chat_room}/${page}/${limit}`);
  }

}
